export enum ProductClass {
    PhysicalProduct = 0,
    GiftCard = 1
}
